import { USER_EMAIL_ID, USER_NAME } from "../Constants/StorageConstants";

export const getUserDetails = () => {
  return {
    email: localStorage.getItem(USER_EMAIL_ID),
    firstName: localStorage.getItem(USER_NAME),
    lastName: "",
    profileUrl: `https://ui-avatars.com/api/?name=${localStorage.getItem(USER_NAME)}&background=0D8ABC&color=fff`,
    role: "Architect - Services", //TODO: remove this harcoded value and take it from server
  };
};

export const getUserName = () => {
  const userDetails = getUserDetails();
  return userDetails ? `${userDetails.firstName} ${userDetails.lastName || ""}` : "";
};

export const getUserProfileImage = () => {
  const userDetails = getUserDetails();
  return userDetails ? userDetails.profileUrl : null;
};

export const getUserEmail = () => {
  const userDetails = getUserDetails();
  return userDetails ? userDetails.email : null;
};
